import { Component, Inject, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { take } from 'rxjs';
import { AuthenticationService } from '../../services/AuthenticationService';

@Component({ standalone: false,
  selector: 'app-mfa-recovery-dialog',
  templateUrl: 'mfa-recovery-dialog.component.html',
  styleUrls: ['mfa-recovery-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class MFARecoveryDialogComponent {
  public userId!:string;
  public title: string= "Title";
  public message: string = "";
  public recoveryMessage: string = "A one-time recovery token has been sent to your email on file. Please enter this token within 30 minutes.";
  public postRecoveryMessage: string = "To fully recover your multi-factor authentication, follow the steps below:<br><br>1.Login to your account<br>2.Go to your account profile<br>3.Within the Security section of your profile, disable multi-factor authentication<br>4.Within the Security section of your profile, re-enable multi-factor authentication<br>.";
  public confirmButtonText = "Yes";
  public cancelButtonText = "Cancel";
  public busy:boolean=false;

  public dialogForm: FormGroup;

  public showCancelButton:boolean = true;
  public recoveryContext:boolean=true;
  public postRecoveryContext:boolean=false;

  private forceTwoFactor:boolean=false;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<MFARecoveryDialogComponent>, private authService:AuthenticationService, public snackBar: MatSnackBar) {
    this.dialogForm = new FormGroup({
      code: new FormControl('', [Validators.required]),
    });
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
        this.userId = data.userId;
        this.forceTwoFactor = data.forceTwoFactor; //not used in this application right now
    }
  }

  onRecoveryClicked(): void {
    this.recoveryContext=true;
  }

  onConfirmClick(): void {
    if(!this.postRecoveryContext){
       //validate the recovery code; if not valid, stay in dialog, if valid check if MFA is mandated (forced). 
      //if mandated then push user to MFA setup, if not mandated, show message to advise user to deactivate and reactivate MFA in his profile
      this.busy=true;
      this.authService.validateTwoFactorRecovery(this.userId, this.dialogForm.get('code')!.value).pipe(take(1)).subscribe(r=>{
        this.busy=false;
        if(r.success){
          if(this.forceTwoFactor){
            this.dialogRef.close(true);
          }
          else{
            //not customer mandated => advise user what to do next
            this.showCancelButton=false;
            this.confirmButtonText="OK";
            this.postRecoveryContext=true;
            this.recoveryContext=false;
          }
        }
        else this.snackBar.open("Invalid code", '×', { panelClass: ['warn-snackbar'], verticalPosition: 'top' });
      });
    }
    else{
      this.dialogRef.close(true);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

}